const PAID: 'paid' = 'paid'
const UNPAID: 'unpaid' = 'unpaid'
const BLOCKED: 'blocked' = 'blocked'
const IMPORTED: 'imported' = 'imported'
const BLOCKED_IMPORT: 'blocked-import' = 'blocked-import'
const ON_HOLD: 'on_hold' = 'on_hold'

const STATUSES = { PAID, UNPAID, BLOCKED, IMPORTED, BLOCKED_IMPORT, ON_HOLD }
type reservationStatus = typeof PAID | typeof UNPAID | typeof BLOCKED | typeof IMPORTED | typeof BLOCKED_IMPORT | typeof ON_HOLD

export {STATUSES}
export type { reservationStatus }
